<template>
  <div>
    <input
      class="accordion__input"
      type="radio"
      :id="`accordion-rd-${idx}-${accordionKey}`"
      :name="`accordion-rd`"
      @click="toggleRadio(`accordion-rd-${idx}-${accordionKey}`)"
    />
    <label
      class="accordion__tab-label"
      :for="`accordion-rd-${idx}-${accordionKey}`"
    >
      <span>
        <template v-if="item.iconOpen && item.iconClosed">
          <template v-if="isOpen">
            <img
              v-if="'iconOpenImagePath' in item"
              class="accordion__icon-image-path"
              :src="item.iconOpenImagePath"
            /> 
            <font-awesome-icon v-else :icon="['fa', item.iconOpen]"/>
          </template>
          <template v-if="!isOpen">
            <img
              v-if="'iconClosedImagePath' in item"
              class="accordion__icon-image-path"
              :src="item.iconClosedImagePath"
            />
            <font-awesome-icon v-else :icon="['fa', item.iconClosed]"/>
          </template>
        </template>
        <template v-else-if="'iconImagePath' in item">
          <img
            class="accordion__icon-image-path"
            :src="item.iconImagePath"
          />
        </template>
        <template v-else-if="item.icon">
          <font-awesome-icon :icon="['fa', item.icon]"/>
        </template>
        {{ item.title }}
      </span>
    </label>
    <div class="accordion__tab-content" v-html="item.description"/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radioState: false,
      isOpen: false,
    }
  },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    idx: {
      type: Number,
      default: 0
    },
    accordionKey: {
      type: Number,
      default: 0
    },
    activeAccordion: {
      type: String,
      default: ''
    }
  },
  methods: {
    toggleRadio(id) {
      this.$emit('toggle', id)
      if (this.radioState === false) {
        this.radioState = true
        this.isOpen = true
      } else {
        document.getElementById(id).checked = false
        this.radioState = false
        this.isOpen = false
      }
      
    }
  },
  watch: {
    activeAccordion: {
      handler() {
        if (this.activeAccordion !== `accordion-rd-${this.idx}-${this.accordionKey}`) {
          this.radioState = false
          this.isOpen = false
        }
      },
    }
  }
}
</script>
<style lang="scss">
  .accordion__icon-image-path {
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
  } 
</style>